import { HStack, useBreakpointValue, VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Text } from "@repo/core/components/core/Text";
import { ProposaLocationSectionProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { MustShow } from "@repo/core/components/core/MustShow";

export const ProposalLocationSection = ({
  name,
  region,
  address,
  isShowEditButton,
  onPressChangeLocation
}: ProposaLocationSectionProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <VStack gap="$2">
      <Text fontSize="$xs" fontWeight={500} color="$textLight700">
        Ponto de Atendimento
      </Text>
      <VStack
        p="$2"
        borderWidth={1}
        borderRadius="$lg"
        bg="$backgroundLight50"
        borderColor="$borderLight100"
      >
        <HStack gap="$3">
          <VStack alignItems="center" justifyContent="center">
            <Icon name="location-dot" size={24} color="$primary700" />
          </VStack>
          <VStack justifyContent="center" flex={1} gap="$1">
            <Text fontSize="$sm" fontWeight={600} color="$textLight900">
              {name}
            </Text>
            <Text fontSize="$sm" fontWeight={500} color="$textLight800">
              {region}
            </Text>
            {address && (
              <Text fontSize="$xs" color="$textLight800">
                {address}
              </Text>
            )}
          </VStack>

          <MustShow isVisible={!isMobile && isShowEditButton}>
            <Button
              variant="outline"
              action="secondary"
              size="md"
              text="Alterar"
              leftIcon={{
                name: "pen-square",
                color: "$secondary900",
                size: 20
              }}
              onPress={onPressChangeLocation}
            />
          </MustShow>
        </HStack>
      </VStack>
      {isMobile && isShowEditButton && (
        <Button
          variant="outline"
          action="secondary"
          size="md"
          text="Alterar PA"
          leftIcon={{
            name: "pen-square",
            color: "$secondary900",
            size: 20
          }}
          onPress={onPressChangeLocation}
        />
      )}
    </VStack>
  );
};
